<template>
  <form-layout :label="label" :required="required" :optional="optional">
    <div class="row" :class="errorMessage ? 'is-invalid' : ''">
      <div class="col-auto">
        <select class="form-select" :class="errorMessage ? 'is-invalid' : ''" v-model="value">
          <option v-if="!editMode" />
          <option v-for="option in options" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </div>
      <div class="col d-flex align-items-center">
        <base-button class="btn-sm btn-light border-dark" text="絞込" @click="doBuildingFilter" />
      </div>
    </div>
    <div class="invalid-feedback">{{ errorMessage }}</div>
    <span v-if="warningMessage" class="form-text text-secondary">{{ warningMessage }}</span>
    <span v-if="editMode" class="form-text">物件を変更する場合は絞込を実行してください</span>
  </form-layout>
  <teleport to="body">
    <building-filter-modal ref="buildingFilterModal" />
  </teleport>
</template>
<script>
import BaseVuexFormItem from "@/views/molecules/formItems/BaseVuexFormItem";
import FormLayout from "@/views/templates/FormLayout";
import BaseButton from '@/views/atoms/BaseButton'
import BuildingFilterModal from '@/views/pages/IssuanceRequest/modals/BuildingFilterModal'

export default {
  name: "VuexBuildingFormItem",
  extends: BaseVuexFormItem,
  components: {
    BaseButton,
    FormLayout,
    BuildingFilterModal,
  },
  props: {
    label: {
      type: String,
      default: '依頼物件選択'
    },
    required: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
  },
  computed: {
    editMode() {
      return !!this.$store.state[this.vuex_module]?.data?.id;
    },
    warningMessage() {
      return this.$store.state[this.vuex_module]?.warnings?.[this.vuex_column]?.[0];
    },
  },
  methods: {
    doBuildingFilter() {
      this.$refs.buildingFilterModal.show();
    }
  }
}
</script>

<style scoped>
select {
  min-width: 250px;
}
</style>
